import { STEP_STATES } from '@bingads-webui-react/wizard-core';

/**
 * Define this file to simplify later logging mapping in consumer side.
 */
export const WIZARD_EVENT_PREFIX = 'WizardStepFlow:';

export const WIZARD_STEP_EVENT = {
  APP_LOAD: 'AppLoad',
  START_FLOW: 'StartedFlow',
  SWITCH_FLOW: 'SwitchedFlow',
  ENTER_PAGE: 'EnteredPage',
  COMPLETE: 'WizardComplete',
};

export const SINGLE_STEP_EVENT = {
  LOADING: 'Loading',
  SAVING_SUCCEEDED: 'SavingSucceeded',
  SAVING_FAILED: 'SavingFailed',
};

export const USER_TRIGGER_STEP_EVENT = {
  [STEP_STATES.GOING_NEXT]: 'SaveAndGoNext',
  [STEP_STATES.GOING_BACK]: 'SaveAndGoBack',
  [STEP_STATES.EXITING]: 'SaveAndExit',
};

export const USER_TRIGGER_STEP_EVENT_KEYS = Object.keys(USER_TRIGGER_STEP_EVENT);
